import React, { useState, useEffect } from "react";
import "../Assests/Scss/SWResults.scss";
import axios from "axios";
import { useSelector } from "react-redux";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import {
  exportToExcel,
  AssessmentName,
} from "../../Student/Reusablecomponents/RegularFunctions";
// import Dropdown from "../../Student/Reusablecomponents/DropDown";
import { RiFileExcel2Fill } from "react-icons/ri";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import { InstituteGrades, ResultsElectiveSubject } from "../../ReusableComponents/CommonApis";

const StudentwiseR = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const StudenTeacher = JSON.parse(localStorage.getItem("T2S"));
  const HQTP = JSON.parse(localStorage.getItem("NTP"));
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const [Load, SetLoad] = useState(false);

  const [SWRData, SetSWRData] = useState();
  const [TotalData, SeTotalData] = useState();
  const [SelectGrade, SetSelectGrade] = useState(StudenTeacher?.Grade);
  const [RPCount, SetRPCount] = useState();
  // const [ElectiveSubjects, SetElectiveSubjects] = useState([]);

  const GetStudentRegParCount = async () => {
    await axios.get(process.env.REACT_APP_API_BASE_URL +
      `/School/GetStudentRegParCount?ContestCreationId=${location.state?.CCID || SelectDate?.value
      }&SchoolId=${HQTP?.SchoolId || items.schoolId
      }&AssessmentType=${location.state?.TType || SelectDate?.assessmentType}&Grade=${SelectGrade}&InstituteId=${items?.instituteId
      }`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
      .then((res) => { SetRPCount(res.data); })
      .catch((err) => { SetRPCount(); });
  };

  const GetStudentResponseData = async () => {
    SetSWRData();
    SetLoad((prev) => !prev);
    await axios.get(process.env.REACT_APP_API_BASE_URL +
      `/School/GetStudentResponseData?ContestCreationId=${location.state?.CCID || SelectDate?.value
      }&Class=${SelectGrade}&AssessmentType=${location.state?.TType || SelectDate?.assessmentType}&SchoolId=${HQTP?.SchoolId || items.schoolId
      }`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
      .then((res) => {
        if (res.data[0].studentId) {
          if (SelectGrade >= 11) {
            SeTotalData(res.data);
            // GetElectiveSubject(res.data);
          } else {
            SetSWRData(res.data);
          }
        } else {
          SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
      });
  };

  // const GetElectiveSubject = async (data) => {
  //   SetElectiveSubjects([]);
  //   await axios .get( process.env.REACT_APP_API_BASE_URL +
  //       `/School/GetSubjectCategoryForGrade?LovCategoryId=67`,
  //       { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
  //     )
  //     .then((res) => {
  //       const Subjects = res.data.map((sub) => sub.lovDescription);
  //       SetElectiveSubjects(Subjects);
  //       FilterElectivedata(StudenTeacher?.Subject || Subjects[0], data);
  //     })
  //     .catch((err) => { console.log(err); });
  // };
  const [ASSGrade, SetAssGrade] = useState();

  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(items?.instituteId, { value: location.state?.CCID || SelectDate?.value, assessmentType: location.state?.TType || SelectDate?.assessmentType }, USYear?.value, items?.userId);
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(Grades?.map((grade) => ({ Name: `Grade ${grade}`, Value: grade })));
    if (!SelectGrade) {
      SetSelectGrade(Grades?.[0]);
    }
  }
  useEffect(() => {
    if (SelectGrade) {
      GetStudentResponseData();
      GetStudentRegParCount();
    }
    GetAssmentdates();
  }, [SelectGrade]);

  const FilterElectivedata = (Sub, data) => {
    SetLoad(true);
    const Filter = data?.filter((item) => item.subject3Name === Sub);
    if (Filter?.length > 0) {
      SetSWRData(Filter);
    } else {
      SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
    }
    SetLoad(false);
  };
  const OpenPerformanceReport = (row) => {
    const TS = {
      Studentid: row.userId,
      Grade: SelectGrade,
      StudentName: row.studentName,
      StudentRollno: row.studentId,
      mediumOfInstruction: row.mediumOfInstruction,
      MediumName: row.mediumOfInstructionVal,
      AssessmentTypeName: location.state?.AssessmentTypeName
    };
    localStorage.setItem("T2S", JSON.stringify(TS));
    if (location.state?.TType === 3) {
      navigate(`/Samagra/LoPerformance`, {
        state: { userId: row.userId, CCID: location.state?.CCID || SelectDate?.value, TType: location.state?.TType || SelectDate?.assessmentType, Grade: SelectGrade, Medium: row.mediumOfInstruction, Date: location.state?.AssessmentDate }
      });
    } else {
      navigate(`/LoPerformanceReport`, {
        state: {
          CCID: location.state?.CCID || SelectDate?.value, TType: location.state?.TType || SelectDate?.assessmentType, Grade: SelectGrade
          , Subjects: [SWRData?.[0].subject1Name, SWRData?.[0].subject2Name, SWRData?.[0].subject3Name].join(",")
        }
      });
    }

  };

  const OpenViewAnswerSheet = (row) => {
    const TS = {
      Studentid: row.userId,
      Grade: SelectGrade,
      StudentName: row.studentName,
      StudentRollno: row.studentId,
      mediumOfInstruction: row.mediumOfInstruction,
      MediumName: row.mediumOfInstructionVal,
      AssessmentTypeName: location.state?.AssessmentTypeName
    };
    localStorage.setItem("T2S", JSON.stringify(TS));
    navigate(`/ViewAnswerSheetDetails/ViewAnswerSheet`, {
      state: {
        CCID: location.state?.CCID || SelectDate?.value, TType: location.state?.TType || SelectDate?.assessmentType, Grade: SelectGrade
        //   , Subjects: location.state?.TType !== 3 ? [SWRData?.[0].subject1Name, SWRData?.[0].subject2Name, SWRData?.[0].subject3Name, SWRData?.[0].subject4Name].join(",") : SWRData?.[0]?.totalSubjects
        // }
        , Subjects:
          location.state?.TType !== 3
            ? [
              row.subject1Name,
              row.subject2Name,
              row.subject3Name,
              row.subject4Name,
            ]
              .filter(Boolean)
              .join(",")
            : row.totalSubjects,
      },
    });
  };
  // const DownloadSWR = () => {
  //   // const subjectCount = location.state?.TType === 3 ? (SWRData?.[0]?.TotalSubScore?.split(",").length || 2) : 3;
  //   // const subjectCount = getSubjectCount(SWRData?.[0]);
  //   const subjectCount =
  // (location.state?.TType || SelectDate?.assessmentType) === 3
  //   ? 2
  //   : getSubjectCount(SWRData?.[0]);
  //   const XL = SWRData?.map((item, index) => {
  //     const row = {
  //       SNo: index + 1,
  //       "Student ID": item.studentId,
  //       Student: item.studentName,
  //     };

  //     // Dynamically add subject columns
  //     for (let i = 1; i <= subjectCount; i++) {
  //       const subName = SWRData?.[0]?.[`subject${i}Name`];
  //       row[`${subName} Score`] = item[`subject${i}Score`];
  //       row[`${subName} %`] = `${item[`subject${i}Percentage`]} %`;
  //     }
  //     row["Total Score"] = item.totalScore;
  //     row["Total %"] = item.totalPercentage;
  //     return row;
  //   });
  //   exportToExcel(XL, `Student Subject Wise Result ${location.state?.AssessmentDate}`, false, "Subject Wise Result");
  // };

  const DownloadSWR = (exportData = SWRData, subjectName = "") => {
    if (!exportData?.length) return;

    const subjectCount =
      (location.state?.TType || SelectDate?.assessmentType) === 3
        ? 2
        : getSubjectCount(exportData[0]);

    const XL = exportData.map((item, index) => {
      const row = {
        SNo: index + 1,
        "Student ID": item.studentId,
        Student: item.studentName,
        Medium: item.mediumOfInstructionVal,
      };

      // Subject-wise columns
      for (let i = 1; i <= subjectCount; i++) {
        const subName = exportData[0][`subject${i}Name`];

        row[`${subName} Score`] = item[`subject${i}Score`];
        row[`${subName} %`] = `${item[`subject${i}Percentage`]} %`;
      }

      row["Total Score"] = item.totalScore;
      row["Total %"] = `${item.totalPercentage} %`;

      return row;
    });

    exportToExcel(
      XL,
      `Student Subject Wise Result ${location.state?.AssessmentDate}`,
      false,
      "Subject Wise Result"
    );
  };

  const SelectESubject = (e) => {
    localStorage.removeItem("T2S");
    FilterElectivedata(e, TotalData);
  };

  //   const AssessmentDeatils = () => {
  //   const subjectCount = getSubjectCount(SWRData?.[0]);
  //   const subjects = Array.from({ length: subjectCount }, (_, i) => ({
  //     name: SWRData?.[0]?.[`subject${i + 1}Name`],
  //     count: Number(SWRData?.[0]?.[`subject${i + 1}QCount`] || 0),
  //   }));
  //   const total = subjects.reduce((sum, s) => sum + s.count, 0);
  //   const MC = total * 2;
  //   return (
  //     <>
  //       Total Questions : {total}
  //       (
  //       {subjects.map((s, i) => (
  //         <span key={i}>
  //           {s.name}-{s.count}
  //           {i !== subjects.length - 1 && ","}
  //         </span>
  //       ))}
  //       ) | Max Credits : {MC}
  //     </>
  //   );
  // };
  const AssessmentDeatils = (data = SWRData) => {
    const row = data?.[0];
    // const subjectCount = getSubjectCount(row);
    const subjectCount =
      (location.state?.TType || SelectDate?.assessmentType) === 3
        ? 2
        : getSubjectCount(row);

    const subjects = Array.from({ length: subjectCount }, (_, i) => ({
      name: row?.[`subject${i + 1}Name`],
      count: Number(row?.[`subject${i + 1}QCount`] || 0),
    }));

    const total = subjects.reduce((sum, s) => sum + s.count, 0);
    const MC = total * 2;

    return (
      <>
        Total Questions : {total}
        (
        {subjects.map((s, i) => (
          <span key={i}>
            {s.name}-{s.count}
            {i !== subjects.length - 1 && ", "}
          </span>
        ))}
        ) | Max Credits : {MC}
      </>
    );
  };
  const getSubjectCount = (row) => {
    if (!row) return 0;

    let count = 0;

    while (
      row[`subject${count + 1}Name`] &&
      row[`subject${count + 1}Name`].trim() !== ""
    ) {
      count++;
    }

    return count;
  };


  const GetOptionalColumns = (data) => {
    if (!data || data.length === 0) return [];
    // const subjectCount = getSubjectCount(data[0]);
    const subjectCount =
      (location.state?.TType || SelectDate?.assessmentType) === 3
        ? 2
        : getSubjectCount(data[0]);
    return [
      { name: "Student Id", selector: "studentId", sortable: true },

      {
        name: "Student Name",
        selector: "studentName",
        sortable: true,
        cell: (row) => (
          <div style={{ textAlign: "justify" }}>
            {row.studentName}
          </div>
        ),
      },
      {
        name: "Medium",
        selector: "mediumOfInstructionVal",
        sortable: true,
      },
      ...Array.from({ length: subjectCount }, (_, i) => ({
        name: data[0][`subject${i + 1}Name`],
        subColumns: [
          {
            name: "Score",
            selector: `subject${i + 1}Score`,
            sortable: true,
          },
          {
            name: "%",
            selector: `subject${i + 1}Percentage`,
            sortable: true,
            cell: (row) =>
              `${row[`subject${i + 1}Percentage`]}%`,
          },
        ],
      })),
      {
        name: "Total",
        subColumns: [
          {
            name: "Score",
            selector: "totalScore",
            sortable: true,
          },
          {
            name: "%",
            selector: "totalPercentage",
            sortable: true,
            cell: (row) => `${row.totalPercentage}%`,
          },
        ],
      },
      {
        name: "View Answer sheet",
        cell: (row) => (
          <div
            className="CPointer"
            onClick={() => OpenViewAnswerSheet(row)}
            title="View Answer sheet"
          >
            <FaRegEye />
          </div>
        ),
      },
      {
        name: "LO Performance",
        cell: (row) => (
          <div
            onClick={() => OpenPerformanceReport(row)}
            className="CPointer"
            title="View LO Performance"
          >
            <FaRegEye />
          </div>
        ),
      },
    ];
  };

  const SUbHeadercolumns = [
    { name: "Student Id", selector: "studentId", sortable: true },

    {
      name: "Student Name",
      selector: "studentName",
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "justify" }}>
          {row.studentName}
        </div>
      ),
    },

    {
      name: "Medium",
      selector: "mediumOfInstructionVal",
      sortable: true,
    },

    ...(SWRData?.[0]
      ? Array.from(
        {
          length:
            (location.state?.TType || SelectDate?.assessmentType) === 3
              ? 2
              : getSubjectCount(SWRData[0]),
        },
        (_, i) => ({
          name: SWRData[0][`subject${i + 1}Name`],
          subColumns: [
            {
              name: "Score",
              selector: `subject${i + 1}Score`,
              sortable: true,
            },
            {
              name: "%",
              selector: `subject${i + 1}Percentage`,
              sortable: true,
              cell: (row) =>
                `${row[`subject${i + 1}Percentage`]}%`,
            },
          ],
        })
      )
      : []),

    {
      name: "Total",
      subColumns: [
        {
          name: "Score",
          selector: "totalScore",
          sortable: true,
        },
        {
          name: "%",
          selector: "totalPercentage",
          sortable: true,
          cell: (row) => `${row.totalPercentage}%`,
        },
      ],
    },

    {
      name: "View Answer sheet",
      cell: (row) => (
        <div
          className="CPointer"
          onClick={() => OpenViewAnswerSheet(row)}
          title="View Answer sheet"
        >
          <FaRegEye />
        </div>
      ),
    },

    {
      name: "LO Performance",
      cell: (row) => (
        <div
          onClick={() => OpenPerformanceReport(row)}
          className="CPointer"
          title="View LO Performance"
        >
          <FaRegEye />
        </div>
      ),
    },
  ];
  const hasSubject4 = Boolean(SWRData?.[0]?.subject4Name);

  return (
    <div className="TeacherBgImage ">
      <InternetChecking />
      <div className="MainHeading">
        Student wise Results of {AssessmentName(location.state?.TType || SelectDate?.assessmentType)} - {location.state?.AssessmentDate || SelectDate?.examStartDate}
      </div>
      <TabViewValues Tabs={ASSGrade} Selectedtab={SelectGrade} onClick={(e) => { SetSelectGrade(e); SeTotalData([]) }} />

      <div className="dflex alignitems RFilter mt-1">
        {SelectGrade >= 11 && TotalData?.length > 0 && (
          <ResultsElectiveSubject className="NCLDropdown" labelname="Elective Subject :"
            // SOption={StudenTeacher?.Subject}
            onChange={(e) => { SelectESubject(e); }} CCID={location.state?.CCID || SelectDate?.value} AType={location.state?.TType || SelectDate?.assessmentType} />
          // <Dropdown
          //   className="NCLDropdown"
          //   options={ElectiveSubjects}
          //   onChange={(e) => {
          //     SelectESubject(e);
          //   }}
          //   selectoption={StudenTeacher?.Subject}
          //   labelname="Elective Subject : "
          // />
        )}

      </div>
      {/* <div className="SWRDetails dflex mt-2 JSBetween alignitems">
        <div>
          {" "}
          {SWRData?.[0].studentId && (
            <>
              <b>Registered :</b>
              {RPCount?.[0]?.studentRegistered} |<b>Participated :</b>
              {RPCount?.[0]?.studentParticipation}
            </>
          )}{" "}
        </div>
        <div>
          {SWRData?.[0]?.studentId && SelectGrade >= 11 && (
            <>
              {AssessmentDeatils()}
              <div
                className="ExportExcel"
                onClick={() => DownloadSWR(SWRData)}
              >
                <RiFileExcel2Fill /> Export
              </div>
            </>
          )}
        </div>
      </div> */}
      {SWRData?.[0]?.studentId && (
        <div className="SWRDetails dflex JSBetween alignitems mt-2" style={{ marginTop: "20px", marginBottom: "10px" }}>
          <div>
            <b>Registered :</b> {RPCount?.[0]?.studentRegistered} |
            <b> Participated :</b> {RPCount?.[0]?.studentParticipation}
          </div>
          {!hasSubject4 && (
            <div className="dflex alignitems">
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "#000",
                  marginRight: "15px",
                }}
              >
                {AssessmentDeatils(SWRData)}
              </div>

              <div
                className="ExportExcel"
                onClick={() => DownloadSWR(SWRData)}
              >
                <RiFileExcel2Fill /> Export
              </div>
            </div>
          )}
        </div>
      )}

      {SelectGrade >= 11 ? (
        <div className="Card">
          {SWRData?.[0]?.studentId ? (
            <SubHeadersDataTable
              DisplaySearch={true}
              ShowPagination={true}
              Dropdownvalues={[10, 25, 50, 100]}
              data={SWRData}
              ShowPagecount={true}
              columns={SUbHeadercolumns}
              className="NCLDataTable"
            />
          ) : (
            <div className="ErrorMessage">{SWRData}</div>
          )}
        </div>
      ) : (
        <>
          {SWRData?.length > 0 && SWRData?.[0]?.studentId && (
            hasSubject4 ? (
              items?.languageSubjectName?.split(",").map((OP, index) => {
                const subjectData = SWRData?.filter(
                  (item) => item.subject4Name === OP
                );

                if (subjectData?.length === 0) return null;

                return (
                  <div key={index}>
                    <div className="dflex JSBetween alignitems mb-2 mt-4">
                      <h6>Subject: {OP}</h6>

                      <div className="dflex alignitems">
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "400",
                            color: "#000",
                            marginRight: "15px",
                          }}
                        >
                          {AssessmentDeatils(subjectData)}
                        </div>

                        <div
                          className="ExportExcel"
                          onClick={() => DownloadSWR(subjectData, OP)}
                        >
                          <RiFileExcel2Fill /> Export
                        </div>
                      </div>
                    </div>

                    <SubHeadersDataTable
                      DisplaySearch={true}
                      ShowPagination={true}
                      Dropdownvalues={[10, 25, 50, 100]}
                      data={subjectData}
                      ShowPagecount={true}
                      columns={GetOptionalColumns(subjectData)}
                      className="NCLDataTable Card"
                    />
                  </div>
                );
              })
            ) : (
              <>
                <div className="dflex JSBetween alignitems mb-2 mt-2">
                  <div></div>

                  {/* <div className="dflex alignitems">
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "400",
                        color: "#000",
                        marginRight: "15px",
                      }}
                    >
                      {AssessmentDeatils(SWRData)}
                    </div>

                    <div
                      className="ExportExcel"
                      onClick={() => DownloadSWR(SWRData)}
                    >
                      <RiFileExcel2Fill /> Export
                    </div>
                  </div> */}
                </div>

                <div className="Card">
                  <SubHeadersDataTable
                    DisplaySearch={true}
                    ShowPagination={true}
                    Dropdownvalues={[10, 25, 50, 100]}
                    data={SWRData}
                    ShowPagecount={true}
                    columns={GetOptionalColumns(SWRData)}
                    className="NCLDataTable"
                  />
                </div>
              </>
            )
          )}
        </>
      )}
      {Load && <Loading />}
    </div>
  );
};

export default StudentwiseR;
